// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__TNNeh","author":"Table_author__J74NB","authorImage":"Table_authorImage__110P2","unreadRow":"Table_unreadRow__1MxiY"};